module.exports = __webpack_public_path__ + "img/064-magician.1dd65b54.png";